export const getModalRoot = () => {
    const modalRoot = document.getElementById("modal-root");

    if (!modalRoot) {
        const newModalRoot = document.createElement("div");
        newModalRoot.id = "modal-root";
        document.body.appendChild(newModalRoot);
        return newModalRoot;
    }

    return modalRoot;
};
